import { render } from "./IconElectraArtistSeries.vue?vue&type=template&id=b7f8ebc8"
import script from "./IconElectraArtistSeries.vue?vue&type=script&lang=js"
export * from "./IconElectraArtistSeries.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__